// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpaceMembersList__container-ff7f61 {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  padding-bottom: 10px;
}

.SpaceMembersList__placeholders-e3b146 {
  padding: 8px 24px;
}

.SpaceMembersList__no-content-bb75ba {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-80);
  margin-bottom: var(--header-height);
  padding: 0 20px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/SpaceMembersPopup/SpaceMembersList/SpaceMembersList.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,OAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,0CAAA;EACA,qBAAA;EACA,mCAAA;EACA,eAAA;EACA,kBAAA;AACF","sourcesContent":[".container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow-y: auto;\n  padding-bottom: 10px;\n}\n\n.placeholders {\n  padding: 8px 24px;\n}\n\n.no-content {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: center;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-80);\n  margin-bottom: var(--header-height);\n  padding: 0 20px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SpaceMembersList__container-ff7f61`,
	"placeholders": `SpaceMembersList__placeholders-e3b146`,
	"no-content": `SpaceMembersList__no-content-bb75ba`,
	"noContent": `SpaceMembersList__no-content-bb75ba`
};
module.exports = ___CSS_LOADER_EXPORT___;
